import { createSelector } from '@reduxjs/toolkit';

import { ComponentDesignTimestamps } from '@paragon/contract-library';

import { getLoadedComponentDesignsWithInformation } from './trusses';

export const getAllLoadedTimestampsByComponentDesignGuid = createSelector(
  getLoadedComponentDesignsWithInformation,

  (loadedComponentDesignsWithInformationByAnalysisSetGuid) => {
    const componentDesignsWithInformation = Object.values(loadedComponentDesignsWithInformationByAnalysisSetGuid);
    const timestamps: { [componentDesignGuid: string]: ComponentDesignTimestamps } = {};
    for (const componentDesignWithInformation of componentDesignsWithInformation) {
      timestamps[componentDesignWithInformation.componentDesign.guid] = componentDesignWithInformation.timestamps;
    }
    return timestamps;
  },
);
